import { defineStore } from 'pinia'
// @ts-ignore
import { historyType } from './type'
import { usePermissionStore } from '@/stores/modules/permission'
import { recursion } from '@/utils/tools'
import { getCache, setCache } from '@/utils/cache/local'
import { getUrlParams } from '@/utils/util'
import { reNameMenuList, getMenuByAppcode, getMenuByMenuId } from '@/router/utils'
import { router } from '@/router'

import { useTemCache } from '@/stores/modules/temCache'
import { BIcacheData } from '@/enums/BIcache'
import { BIcacheJobData } from '@/enums/BIcache'
import useRouteCache from '@/hooks/useRouteCache'
import { removeAllKeyupListeners } from '@/utils'

const { removeCache, removeAllCache } = useRouteCache()
export const useNavHistory = defineStore({
  id: 'navHistory',
  state: (): {
    history: historyType[]
    activeKey: string
    activeSysCode: string
  } => {
    return {
      history: getCache('navHistory') || [],
      activeKey: '/',
      activeSysCode: ''
    }
  },
  actions: {
    addHistory(value: historyType) {
      const { allMenuList } = usePermissionStore()
      // 路由名称拿后端接口获取到的名称
      recursion(allMenuList, menu => {
        if (menu.path === value.path) {
          value.name = menu.name
          return true
        }
      })
      // 自定义详情的名称处理
      if (value.path === '/customDetailPage') {
        const decodePath = decodeURI(value.fullPath || '')
        const tableCode = getUrlParams('tableCode', decodePath || '')
        const menuId = getUrlParams('menuId', decodePath || '')
        let name = getMenuByAppcode(allMenuList, tableCode).name
        if (menuId) {
          name = getMenuByMenuId(allMenuList, menuId).name
        }
        value.name = name ? name + '详情' : value.name
      }
      if (reNameMenuList.includes(value.path)) {
        // 详情要多个, 通过传递的id来验证唯一性
        const decodePath = decodeURI(value.fullPath || '')
        const fullPath = encodeURI(decodePath || '')
        const id = getUrlParams('id', decodePath || '')
        const res = this.history.find(item => item.id === id)
        if (!res) {
          value.path = fullPath || ''
          value.id = id
          value.name = getUrlParams('realName', decodePath || '') || '详情'
          this.history.push({ ...value, fullPath })
        } else {
          value.path = fullPath || ''
          this.history.forEach(item => {
            if (item.id === id) {
              item.path = fullPath
              item.fullPath = fullPath
            }
          })
        }
      } else {
        const index = this.history.findIndex(item => item.path === value.path)
        if (index > -1) {
          this.history.splice(index, 1, value)
        } else {
          this.history.push(value)
        }
      }
      this.setHistory(this.history)
      this.setActive(value.path)
      this.setActiveSysCode(value.systemCode as string)
    },
    updateHistoryName(name: string, fullPath: string) {
      const decodePath = decodeURI(fullPath || '')
      const encodePath = encodeURI(decodePath || '')
      const res = this.history.find(item => item.fullPath === encodePath)
      if (res) {
        res.name = name
      }
    },
    setActive(path: string) {
      this.activeKey = path
    },
    setActiveSysCode(code: string) {
      this.activeSysCode = code
    },
    closeTag(path: string, isJump = true, callBack?: Fn) {
      const temCache = useTemCache()
      if (path === '/dataCenter/reportCenter/customerAnalysis')
        temCache.removeAppointData(BIcacheData)
      if (path === '/dataCenter/reportCenter/jobAnalysis')
        temCache.removeAppointData(BIcacheJobData)

      const index = this.history.findIndex(item => item.path === path)

      if (callBack) {
        callBack()

        this.history.splice(index, 1)
        this.setHistory(this.history)
        return
      }

      if (path === this.activeKey) {
        if (index !== 0 && this.history?.[index - 1]?.path) {
          this.setActive(this.history[index - 1].path)
        } else if (this.history.length > 1 && this.history?.[index + 1]?.path) {
          this.setActive(this.history[index + 1].path)
        }
        const res = this.history.find(item => item.path === this.activeKey)
        if (res && isJump) {
          router.push(res.fullPath || res.path)
        }
      }
      this.history.splice(index, 1)
      this.setHistory(this.history)
      const handleKeyupKeys = Object.keys(window._CUSTOMERDETAIL_PAGE_KEYUP_EVENT_ || {})
      // 查找this.history中的componentName 是否含有 handleKeyupKeys中的值 如果没有就返回对应key
      const filteredKeys = handleKeyupKeys.filter(key => {
        return !this.history.some(item => item.componentName === key)
      })
      filteredKeys.forEach(key => {
        removeAllKeyupListeners(key)
      })
    },
    closeElse() {
      const temCache = useTemCache()
      const currentMenu = this.history.filter(
        item => item.closeAble || item.path === this.activeKey
      )
      const filteredHistory = this.history.reduce<string[]>((acc, item) => {
        if (!item.closeAble && item.path !== this.activeKey) {
          item.componentName && acc.push(item.componentName)
        }
        return acc
      }, [])
      removeCache(filteredHistory as string[])
      this.setHistory(currentMenu)

      if (currentMenu?.[0]?.path === '/dataCenter/reportCenter/customerAnalysis')
        temCache.removeAppointData(BIcacheJobData)
      if (currentMenu?.[0]?.path === '/dataCenter/reportCenter/jobAnalysis')
        temCache.removeAppointData(BIcacheData)
    },
    closeAll() {
      const temCache = useTemCache()
      this.history = []
      const { systemListData, changeSystem } = usePermissionStore()
      const code = unref(systemListData)?.[0]?.code
      code && changeSystem(unref(systemListData)[0].code, '', true)
      temCache.clearData()
      removeAllKeyupListeners()
      removeAllCache() // 清空路由缓存
    },
    setHistory(list: historyType[]) {
      this.history = list
      setCache('navHistory', this.history)
    }
  }
})
